export const LOGIN_USER_FAIL = "login_user_fail";
export const LOGIN_USER_SUCCESS = "login_user_success";

export const LOGOUT_SUCCESS = "logout_success";
export const LOGOUT_FAILURE = "logout_failure";

export const PERSISTANT_LOGIN = 'persistant_login';
export const PERSISTANT_LOGIN_FAIL = 'persistant_login_fail';

export const GET_USER_DETAILS = "get_user_details";
export const GET_USER_DETAILS_FAILED = "get_user_details_failed";

export const GET_DEVICE_DATA = 'device_data';
export const GET_DEVICE_DATA_FAILED = 'device_data_failed';

export const UPDATE_HEADER_INFO = "update_header_info";
export const UPDATE_HEADER_INFO_FAILED = "update_header_info_failed";

export const UPDATE_FOOTER_INFO = "update_footer_info";
export const UPDATE_FOOTER_INFO_FAILED = "update_footer_info_failed";

export const UPDATE_PROFILE = 'update_profile';
export const UPDATE_PROFILE_FAIL = 'update_profile_fail';

export const SEND_SUCCESS_LOGIN_FEEDBACK = "send_success_login_feedback";

export const GET_CORE_LIST = "get_core_list";
export const GET_CORE_LIST_FAILED = "get_core_list_failed";

export const GET_CORE_VIDEO_LIST = "get_core_video_list";
export const GET_CORE_VIDEO_LIST_FAILED = "get_core_video_list_failed";

export const GET_COURSES_LIST = "get_courses_list";
export const GET_COURSES_LIST_FAILED = "get_courses_list_failed";

export const GET_BOOKMARK_LIST = "get_bookmark_list";
export const GET_BOOKMARK_LIST_FAILED = "get_bookmark_list_failed";

export const GET_UPDATESERIES_LIST = "get_updateseries_list";
export const GET_UPDATESERIES_LIST_FAILED = "get_updateseries_list_failed";

export const GET_GUIDELINES_LIST = "get_guidelines_list";
export const GET_GUIDELINES_LIST_FAILED = "get_guidelines_list_failed";

export const GET_PODCASTS_LIST = "get_podcasts_list";
export const GET_PODCASTS_LIST_FAILED = "get_podcasts_list_failed";

export const APP_TRACK_DATA = "app_track_data";
export const APP_TRACK_DATA_FAILED = "app_track_data_failed";

export const HOME_UPDATES = 'home_updates';
export const HOME_UPDATES_FAILED = 'home_updates_failed'

export const GET_CORE_SECTION = 'get_core_section';
export const GET_CORE_SECTION_FAILED = 'get_core_section_failed';

export const GET_TRANSCRIPTS = 'get_transcripts';
export const GET_TRANSCRIPTS_FAILED = 'get_transcripts_failed';
